<template>
  <div class="page">
    <div class="header">
      <div class="page-content header-wrap">
        <div class="logo">
          <!-- <img src="../assets/images/icons/logo_small.png" /> -->
          <div class="logo-beta">
            <img
              v-if="getDomainFn"
              src="../assets/images/icons/logo_beta.png"
            />
            <img v-else src="../assets/images/icons/logo_beta_cn.png" />
          </div>
        </div>

        <div class="header-right">
          <!-- <div class="menu">
            <div class="menu-item">功能</div>
            <div class="menu-item">指导</div>
            <div class="menu-item">功能</div>
          </div> -->
          <div class="create-btn" @click="goEdit">{{ $t("goCreate") }}</div>
        </div>
      </div>
    </div>
    <div style="height: 61px"></div>
    <div class="banner-container">
      <div class="banner-wrap">
        <div class="left">
          <div class="top">
            <div>
              <img
                v-if="isCN"
                src="../assets/images/icons/newhome/home_banner.png"
              />
              <img
                v-else
                src="../assets/images/icons/newhome/home_banner_en.png"
              />
            </div>
          </div>
          <div class="top-desc">
            {{ $t("homeBannerTitle1") }}<br />
            {{ $t("homeBannerTitle2") }}:
            <span
              :class="{ cate: true, active: 0 === currentIndex }"
              @mouseenter="
                () => {
                  currentIndex = 0;
                  stopInterval();
                }
              "
              @mouseleave="
                () => {
                  currentIndex = 1;
                  startInterval();
                }
              "
            >
              {{ $t("homeBannerCate1") }}
              <img src="../assets/images/icons/newhome/text_shadow.png"
            /></span>

            <span
              :class="{ cate: true, active: 1 === currentIndex }"
              @click="currentIndex = 1"
              @mouseenter="
                () => {
                  currentIndex = 1;
                  stopInterval();
                }
              "
              @mouseleave="
                () => {
                  currentIndex = 2;
                  startInterval();
                }
              "
            >
              {{ $t("homeBannerCate2") }}
              <img src="../assets/images/icons/newhome/text_shadow.png"
            /></span>
            <span
              :class="{ cate: true, active: 2 === currentIndex }"
              @mouseenter="
                () => {
                  currentIndex = 2;
                  stopInterval();
                }
              "
              @mouseleave="
                () => {
                  currentIndex = 0;
                  startInterval();
                }
              "
            >
              {{ $t("homeBannerCate3") }}
              <img src="../assets/images/icons/newhome/text_shadow.png"
            /></span>
            <br />
            {{ $t("homeBannerTitle3") }}
          </div>

          <div
            class="create-btn start shadow"
            style="margin-top: 40px"
            @click="goEdit"
          >
            {{ $t("tryItNow") }}
          </div>
          <div
            style="
              font-size: 14px;
              color: #888888;
              text-align: center;
              width: 219px;
              margin-top: 10px;
            "
          >
            {{ $t("tryTip") }}
          </div>
        </div>
        <div class="right">
          <transition-group name="fade" tag="div" mode="out-in">
            <div class="carousel-item" v-show="currentIndex === 1" key="item-1">
              <ProductCarousel v-if="currentIndex === 1" />
              <img
                src="../assets/images/icons/newhome/banner_product_small.png"
                class="small carousel-img1-small"
              />
            </div>
            <div class="carousel-item" v-show="currentIndex === 0" key="item-0">
              <ModesCarousel :visible="currentIndex === 0" />
              <img
                src="../assets/images/icons/newhome/clothing_small.png"
                class="small carousel-img2-small"
              />
            </div>
            <div class="carousel-item" v-show="currentIndex === 2" key="item-2">
              <div class="carousel-img3">
                <img
                  src="../assets/images/icons/newhome/banner_hand.png"
                  style="width: 100%"
                />
              </div>
              <img
                src="../assets/images/icons/newhome/banner_hand_small.png"
                class="small carousel-img3-small"
              />
            </div>
          </transition-group>
        </div>
      </div>
    </div>

    <HomeProduct
      :isReverse="true"
      :title1="$t('modelsAl')"
      :title2="$t('ordinaryToProfessional')"
      :desc="$t('changeModels')"
      @goEdit="goEdit"
    >
      <template v-slot:right>
        <img
          src="../assets/images/icons/newhome/product1.png"
          class="product-img"
        />
      </template>
    </HomeProduct>

    <HomeProduct
      :title1="$t('modelsAl')"
      :title2="$t('mannequinToPerson')"
      :desc="$t('convertMannequins')"
      @goEdit="goEdit"
    >
      <template v-slot:right>
        <img
          style="float: right"
          class="product-img"
          src="../assets/images/icons/newhome/product2.png"
        />
      </template>
    </HomeProduct>
    <HomeProduct
      :isReverse="true"
      :title1="$t('modelsAl')"
      :title2="$t('headlessImages')"
      :desc="$t('autoGenerateFaces')"
      @goEdit="goEdit"
    >
      <template v-slot:right>
        <img
          src="../assets/images/icons/newhome/product3.png"
          class="product-img"
        />
      </template>
    </HomeProduct>
    <HomeProduct
      :title1="$t('modelsAl')"
      :title2="$t('fullBodyModels')"
      :desc="$t('autoGenerateOutfit')"
      @goEdit="goEdit"
    >
      <template v-slot:right>
        <img
          src="../assets/images/icons/newhome/product4.png?1"
          class="product-img"
        />
      </template>
    </HomeProduct>

    <!-- <HomeProduct
      :isReverse="true"
      title1="AI模特"
      title2="专属模特定制"
      desc="提供模特图片，定制您的专属AI模特"
      @goEdit="goEdit"
    >
      <template v-slot:right>
        <img src="../assets/images/icons/newhome/product5.png" />
      </template>
    </HomeProduct> -->

    <HomeProduct
      :title1="$t('productSceneChange')"
      :title2="$t('swapBackground')"
      @goEdit="goEdit"
      :isReverse="true"
    >
      <template v-slot:right>
        <img src="../assets/images/icons/newhome/product6.png" />
        <img
          class="product6-small"
          src="../assets/images/icons/newhome/product6_small.png"
        />
      </template>
    </HomeProduct>

    <div class="banner-tilte">{{ $t("moreAITools") }}</div>
    <MoreTools @goEdit="goEdit" />

    <div class="banner-tilte">{{ $t("whyChooseFashionLabs") }}</div>
    <WhySelect />

    <div class="banner-tilte">{{ $t("customerCaseStudies") }}</div>
    <HomeCases />

    <div class="banner-tilte">{{ $t("startCreatingProfessionalImages") }}</div>
    <div class="start-banner">
      <div class="create-btn start" @click="goEdit">{{ $t("tryItNow") }}</div>
    </div>
    <div
      style="
        font-size: 14px;
        color: #888888;
        text-align: center;
        margin-top: 10px;
      "
    >
      {{ $t("tryTip") }}
    </div>
    <div class="bottom-seize"></div>
    <div v-if="!getDomainFn" class="copyright">
      ©2023 上海绚显科技有限公司 &nbsp;
      <a href="https://beian.miit.gov.cn/#/Integrated/index"
        >沪ICP备20024388号-7</a
      >
    </div>
    <div class="bottom-seize" style="text-align: center; color: #999999">
      上海市青浦区朱家角镇康业路6号1幢5层
    </div>
    <div class="bottom-line" style="height: 2px; background: #fff"></div>
    <LoginDialog></LoginDialog>
  </div>
</template>

<script>
import { getDomainFn } from "@/utils/env";
import registerCode from "@/common/registerCode.js";
import LoginDialog from "@/components/Home/Login.vue";
import HomeProduct from "@/components/Home/HomeProduct.vue";
import MoreTools from "@/components/Home/MoreTools.vue";
import WhySelect from "@/components/Home/WhySelect.vue";
import HomeCases from "@/components/Home/HomeCases.vue";
import ModesCarousel from "@/components/Home/ModesCarousel.vue";
import ProductCarousel from "@/components/Home/ProductCarousel.vue";
import { isLogin } from "@/common/util";
import { getQueryByName, delUrlParam, LocalDataUtil } from "@/common/util";
import { isMobile } from "@/utils/index";

export default {
  name: "AIHome",
  data() {
    return {
      userInfo: {},
      whetherLogin: false,
      isMobile: isMobile(),
      currentIndex: 0,
    };
  },
  components: {
    LoginDialog,
    HomeProduct,
    MoreTools,
    WhySelect,
    HomeCases,
    ModesCarousel,
    ProductCarousel,
  },
  computed: {
    isCN() {
      const browserLocale = navigator.language || navigator.userLanguage;
      return browserLocale.indexOf("zh") > -1;
    },
    getDomainFn() {
      return getDomainFn();
    },
  },
  watch: {
    "$store.state.showLogin": {
      immediate: true,
      handler() {
        // this.getUserInfo();
      },
    },
  },
  mounted() {
    this.checkLogin();
    this.getUserInfo("go");
    this.startInterval();
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  methods: {
    startInterval() {
      clearInterval(this.intervalId);
      this.intervalId = setInterval(this.nextCategory, 6000);
    },
    stopInterval() {
      this.clearInterval();
    },
    clearInterval() {
      clearInterval(this.intervalId);
    },
    nextCategory() {
      this.currentIndex = (this.currentIndex + 1) % 3;
    },
    getUserInfo(type) {
      let data = LocalDataUtil.getItem("aipacewebuserinfo");
      this.userInfo = data ? JSON.parse(data) : {};
      this.whetherLogin = isLogin();
      if (type === "go" && this.whetherLogin) {
        this.replace();
      }
    },
    replace() {
      if (this.userInfo["invited"] === 0) {
        if (LocalDataUtil.getItem("registerode")) {
          this.$store.commit("setShowLogin", false);
          registerCode();
        } else {
          this.$store.commit("setLoginStatus", "Invited");
          this.$store.commit("setShowLogin", true);
        }
      } else {
        this.$router.replace("edit");
      }
    },
    handleLogin() {
      this.$store.commit("setShowLogin", true);
    },
    goEdit() {
      if (!this.getDomainFn) {
        this.$store.commit("setLoginStatus", "PhoneSignIn");
      } else {
        this.$store.commit("setLoginStatus", "SignIn");
      }
      this.getUserInfo();
      if (this.whetherLogin) {
        this.replace();
      } else {
        this.handleLogin();
      }
    },
    async checkLogin() {
      if (document.location.href.indexOf("code=") > -1) {
        const res = await this.$store.dispatch("getThirdLogonToken", {
          code: getQueryByName("code"),
          platform: new Number(getQueryByName("p")),
        });
        console.info(res);
        LocalDataUtil.setItem("aispacewebtoken", res.data.token);
        LocalDataUtil.setItem(
          "aipacewebuserinfo",
          JSON.stringify(res.data.user_info)
        );
        this.getUserInfo("go");
        // 删除登陆后的code
        delUrlParam(["code", "p", "state"]);
      }
      if (
        document.location.href.indexOf("resetkey=") > -1 &&
        document.location.href.indexOf("email=") > -1
      ) {
        // 重置密码
        this.$store.commit("setResetPassword", {
          resetkey: getQueryByName("resetkey"),
          email: getQueryByName("email"),
        });
        this.$store.commit("setLoginStatus", "ResetPassword");
        this.$store.commit("setShowLogin", true);
        delUrlParam(["resetkey", "email"]);
      }
      if (
        document.location.href.indexOf("key=") > -1 &&
        document.location.href.indexOf("userID=") > -1
      ) {
        // 激活账号
        const params = {
          key: getQueryByName("key"),
          userID: getQueryByName("userID"),
        };
        const res = await this.$store.dispatch("postActivate", params);
        if (res.status === "200") {
          this.$store.commit("setLoginStatus", "SignIn");
          this.$store.commit("setShowLogin", true);
          this.$toast({
            type: "success",
            message: this.$t("accountActivationSuccessful"),
            duration: 3,
          });
        } else {
          this.$toast({
            type: "waring",
            message: res.msg,
            duration: 3,
          });
        }
        delUrlParam(["key", "userID"]);
      }
      if (document.location.href.indexOf("registerode=") > -1) {
        let registerode = getQueryByName("registerode");
        LocalDataUtil.setItem("registerode", registerode);
        delUrlParam(["registerode"]);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  background: #fff;
  height: 100vh;
  overflow: auto;
  .header {
    width: 100%;
    height: 61px;
    position: fixed;
    z-index: 200;
    border-bottom: 1px solid #f3f4f5;
    background-color: #fff;
    .header-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;
    }
    .logo {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        height: 23px;
        margin-right: 8px;
      }
    }
    .logo-beta {
      height: 23px;
    }

    .header-right {
      display: flex;
      align-items: center;
      .menu {
        display: flex;
        align-items: center;
        margin-right: 20px;
        .menu-item {
          width: 50px;
          text-align: center;
          font-size: 14px;
          font-family: GothamMedium;
          font-weight: 500;
          color: #000000;
          transition: all 0.15s;
          cursor: pointer;
          &:hover {
            color: #333;
          }
        }
      }
    }
  }

  .page-content {
    width: 1400px;
    margin: 0 auto;
  }

  .banner-container {
    background: linear-gradient(180deg, #ffffff 0%, #f9ecff 51%, #f1efff 100%);
  }
  .banner-wrap {
    width: 1440px;
    margin: 0 auto;
    overflow: hidden;
    min-height: 830px;
    padding-top: 80px;
    padding-bottom: 80px;
    display: flex;
    .left {
      float: left;
      width: 45%;
      padding-left: 20px;
      .top {
        margin-bottom: 20px;
        display: flex;
        align-items: baseline;
        margin-top: 20px;
        img {
          width: 529px;
        }
      }
      .top-desc {
        font-size: 22px;
        font-family: GothamMedium;
        font-weight: 500;
        color: #666666;
        line-height: 42px;
        .cate {
          padding-right: 10px;
          cursor: pointer;
          // transition: all 0.15s;
          display: inline-block;
          position: relative;
          img {
            position: absolute;
            bottom: 0px;
            left: 0;
            opacity: 0;
            transition: all 0.15s;
          }
        }
        .active {
          font-size: 22px;
          font-family: GothamMedium;
          color: #8873ff;
          line-height: 29px;
          background: linear-gradient(180deg, #4e2fff 0%, #af60ff 100%);
          -webkit-background-clip: text;
          display: inline-block;
          -webkit-text-fill-color: transparent;
          transform: skew(-15deg, 0);
          font-weight: 600;
          img {
            opacity: 1;
          }
        }
      }
      .btn-wrap {
        width: 360px;
        height: 260px;
        cursor: pointer;
        margin-top: 50px;
        transition: all 0.15s;
        &:active {
          opacity: 0.9;
        }
      }
    }
    .right {
      float: right;
      width: 55%;
      margin-left: 60px;
      display: flex;
      justify-content: center;
      align-items: baseline;
      margin-top: 20px;

      position: relative;
      .carousel-item {
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        .small {
          position: absolute;
          bottom: -80px;
          left: -80px;
          z-index: 101;
        }
      }
    }
  }

  .bottom-seize {
    height: 50px;
  }

  .banner-tilte {
    font-size: 44px;
    font-family: GothamMedium;
    color: #111111;
    text-align: center;
    padding: 40px 0;
    padding-top: 80px;
    font-weight: 500;
  }
}

.create-btn {
  min-width: 90px;
  height: 36px;
  background: #8873ff;
  border-radius: 32px;
  font-size: 18px;
  font-size: 12px;
  color: #fff;
  font-family: GothamMedium;
  font-weight: bold;
  line-height: 36px;
  cursor: pointer;
  text-align: center;
  transition: all 0.15s;
  padding: 0 10px;
  &.start {
    width: 219px;
    height: 73px;
    background: #8873ff;

    border-radius: 36px;
    line-height: 73px;
    text-align: center;
    color: #ffffff;
    font-size: 26px;
  }
  &.shadow {
    box-shadow: 0px 22px 58px 0px rgba(213, 0, 255, 0.15);
  }
}
.create-btn:hover {
  opacity: 0.85;
}

.start-banner {
  display: flex;
  align-items: center;
  justify-content: center;
}

.copyright {
  margin-top: 40px;
  border-top: 1px solid #f3f4f5;
  width: 100%;
  overflow: hidden;
  height: 60px;
  line-height: 64px;
  text-align: center;
  font-size: 14px;
  color: #999999;
  a:hover {
    color: #000;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.product6-small {
  position: absolute;
  width: 131px;
  height: 187px !important;
  bottom: -55px;
  right: -94px;
}

.product-img {
  height: 610px !important;
}

.carousel-img1 {
  width: 705px;
}

.carousel-img1-small {
  width: 216px;
}

.carousel-img2-small {
  width: 216px;
  bottom: 30px !important;
  left: -140px !important;
}
.carousel-img3 {
  width: 476px;
  img {
    border-radius: 16px;
  }
}

.carousel-img3-small {
  width: 216px;
}

/* 小于等于1440px时应用的样式 */
@media (max-width: 1440px) {
  .carousel-img1 {
    width: 514px;
  }

  .carousel-img1-small {
    width: 158px;
  }

  .carousel-img2-small {
    width: 158px;
    left: -100px !important;
  }

  .carousel-img3 {
    width: 347px;
  }

  .carousel-img3-small {
    width: 158px;
  }

  .product-img {
    height: 468px !important;
  }

  .page {
    min-width: 1200px;
    .header {
      border-bottom: none;
    }
    .page-content {
      width: 1200px;
      margin: 0 auto;
    }
    .flow-banner {
      width: 1200px;
      padding: 45px;
      .flow-item {
        width: 340px;
        padding: 25px;
      }
    }
    .banner-wrap {
      width: 1200px;
      min-height: 640px;
      .left {
        width: 50%;
      }
      .right {
        width: 50%;
      }
    }
  }

  .page .banner-wrap .left .top img {
    width: 397px;
  }
  .page .banner-wrap .left .top-desc {
    font-size: 18px;
    line-height: 31px;
  }
}
</style>
